import{useBindProp as t}from"../props.js";import{setValueOrSetOption as o}from"../../utils/options.js";function i(i,p){t(i,{setter:function(t,i){o(t,"opacity","setOpacity",i)}},p.opacity)}export default i;
